import { Component, OnInit } from '@angular/core';
import { ColorPickerControl } from '@iplab/ngx-color-picker';
import * as svg from 'save-svg-as-png';
import axios from 'axios';
declare var $: any;

@Component({
  selector: 'app-duotone',
  templateUrl: './duotone.component.html',
  styleUrls: ['./duotone.component.css']
})
export class DuotoneComponent implements OnInit {
  duotoneColor: any = {
    from: { rgba: { red: 0.960, green: 0.392, blue: 0.407, alpha: 1 }, hex: '#f56468' },
    to: { rgba: { red: 0.152, green: 0.094, blue: 0.309, alpha: 1 }, hex: '#27184f' },
    type: null,
    matrix: '0.807 0 0 0 0.152 0.298 0 0 0 0.094 0.098 0 0 0 0.309 0 0 0 1 0',
    presets: [
      { from: { rgba: { red: 0.063, green: 0.773, blue: 0.973, alpha: 1 }, hex: '#10c5f8' }, to: { rgba: { red: 0.404, green: 0.212, blue: 0.867, alpha: 1 }, hex: '#6736dd' }, matrix: '-0.339 0 0 0 0.402 0.558 0 0 0 0.210 0.105 0 0 0 0.863 0 0 0 1 0' },
      { from: { rgba: { red: 1, green: 0, blue: 0.157, alpha: 1 }, hex: '#ff0028' }, to: { rgba: { red: 0.478, green: 0, blue: 0.309, alpha: 1 }, hex: '#7a004f' }, matrix: '0.519 0 0 0 0.476 0 0 0 0 0 -0.152 0 0 0 0.308 0 0 0 1 0' },
      { from: { rgba: { red: 1, green: 0.918, blue: 0, alpha: 1 }, hex: '#ffea00' }, to: { rgba: { red: 0.624, green: 0.439, blue: 0.309, alpha: 1 }, hex: '#9f704f' }, matrix: '0.375 0 0 0 0.621 0.476 0 0 0 0.437 -0.308 0 0 0 0.308 0 0 0 1 0' },
      { from: { rgba: { red: 0.149, green: 0.718, blue: 0.627, alpha: 1 }, hex: '#26b7a0' }, to: { rgba: { red: 0.239, green: 0.247, blue: 0.298, alpha: 1 }, hex: '#3d3f4c' }, matrix: '-0.089 0 0 0 0.238 0.468 0 0 0 0.246 0.328 0 0 0 0.296 0 0 0 1 0' },
      { from: { rgba: { red: 0.965, green: 0.804, blue: 0.882, alpha: 1 }, hex: '#f6cde1' }, to: { rgba: { red: 0, green: 0.369, blue: 0.675, alpha: 1 }, hex: '#005eac' }, matrix: '0.960 0 0 0 0 0.433 0 0 0 0.367 0.207 0 0 0 0.671 0 0 0 1 0' },
      { from: { rgba: { red: 0.961, green: 0.392, blue: 0.408, alpha: 1 }, hex: '#f56468' }, to: { rgba: { red: 0.153, green: 0.094, blue: 0.309, alpha: 1 }, hex: '#27184f' }, matrix: '0.807 0 0 0 0.152 0.298 0 0 0 0.094 0.098 0 0 0 0.309 0 0 0 1 0' },
    ]
  };
  colorControl = new ColorPickerControl().hidePresets();

  constructor() { }

  ngOnInit(): void {
    this.colorControl.valueChanges.subscribe((value: any) => {
      let rgba = value.getRgba();
      Object.assign(rgba, { red: (rgba.red / 255).toFixed(3), green: (rgba.green / 255).toFixed(3), blue: (rgba.blue / 255).toFixed(3) });
      switch (this.duotoneColor.type) {
        case 1:
          this.duotoneColor.from = { rgba: rgba, hex: value.toHexString() };
          let toRgba = this.duotoneColor.to.rgba;
          if (toRgba.hasOwnProperty('red')) this.duotoneColor.matrix = `${rgba.red - toRgba.red} 0 0 0 ${toRgba.red} ${rgba.green - toRgba.green} 0 0 0 ${toRgba.green} ${rgba.blue - toRgba.blue} 0 0 0 ${toRgba.blue} 0 0 0 1 0`;
          break;
        case 2:
          let fromRgba = this.duotoneColor.from.rgba;
          this.duotoneColor.to = { rgba: rgba, hex: value.toHexString() };
          if (fromRgba.hasOwnProperty('red')) this.duotoneColor.matrix = `${fromRgba.red - rgba.red} 0 0 0 ${rgba.red} ${fromRgba.green - rgba.green} 0 0 0 ${rgba.green} ${fromRgba.blue - rgba.blue} 0 0 0 ${rgba.blue} 0 0 0 1 0`;
          break;
      }
    });
  }

  fromColor() {
    this.duotoneColor.type = 1;
    this.colorControl.setValueFrom(this.duotoneColor.from.hex);
    $('#colorPicker .modal-dialog').css({ top: '120px', left: '160px' });
    $('#colorPicker').modal('show');
  }

  toColor() {
    this.duotoneColor.type = 2;
    this.colorControl.setValueFrom(this.duotoneColor.to.hex);
    $('#colorPicker .modal-dialog').css({ top: '120px', left: '160px' });
    $('#colorPicker').modal('show');
  }

  duotonePresets() {
    this.duotoneColor.type = 0;
    $('#colorPicker .modal-dialog').css({ top: '365px', left: '160px' });
    $('#colorPicker').modal('show');
  }

  presetClick(preset: any) {
    this.duotoneColor.from = preset.from;
    this.duotoneColor.to = preset.to;
    this.duotoneColor.matrix = preset.matrix;
  }

  fileTrigger() {
    $('#duotoneFile').click();
  }

  fileList: any = [];

  fileChange(event: any) {
    const files = event.target.files;
    this.fileList = [];
    for (let file of files) {
      let obj: any = { name: file.name };
      const reader = new FileReader();
      reader.onload = () => {
        const image: any = new Image();
        image.src = reader.result;
        image.onload = () => {
          obj.width = image.width;
          obj.height = image.height;
        }
        obj.uri = reader.result;
        this.fileList.push(obj);
      }
      reader.readAsDataURL(file);
    }
  }

  isFullscreen: any = false;

  fullscreen(index: any) {
    let file = this.fileList[index];
    if (!this.isFullscreen) {
      $(`#duotone-${index}`).css({ position: 'fixed', width: '100%', height: '100%', top: 0, left: 0, zIndex: 8, margin: 0 });
    } else {
      $(`#duotone-${index}`).css({ position: '', width: '', height: '', top: '', left: '', zIndex: '', margin: '' });
    }
    this.isFullscreen = !this.isFullscreen;
  }

  download(event: any, index: any) {
    event.stopPropagation();
    let file = this.fileList[index];
    svg.saveSvgAsPng(document.getElementById(`svg-duotone-${index}`), file.name, { width: file.width, height: file.height });
  }

  downloads() {
    this.fileList.forEach((file, index) => {
      svg.saveSvgAsPng(document.getElementById(`svg-duotone-${index}`), file.name, { width: file.width, height: file.height });
      setTimeout(() => { }, 1000);
    });
  }

  unsplash: any = { results: [], page: 1 };

  search(query: any, page: any = 1) {
    if (page == -1) return;
    if (this.isFullscreen) this.isFullscreen = false;
    const that = this;
    axios.get(`/search/photos?query=${query}&page=${page}&per_page=30`)
      .then((response) => {
        if (response.data.results.length) {
          that.unsplash.results = [...that.unsplash.results, ...response.data.results];
          that.fileList = that.unsplash.results.map(e => {
            let obj = { name: `${e.id}.png`, uri: e.urls.regular, width: e.width, height: e.height };
            return obj;
          });
          page++;
          that.unsplash.page = page;
        } else {
          that.unsplash.page = -1;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
